// File: whatsapp.service.js
import { formatChatId, _handleError, _extractInviteCode } from './whatsapp.service-utils';
import { getMessages, sendTextMessage, sendFile } from './whatsapp.service-message-ops';
import { getProfilePicture, getContactName } from './whatsapp.service-profile-ops';
import {
  createGroup,
  setGroupPicture,
  setGroupName,
  getGroupInviteInfo,
  joinGroupViaInvite
} from './whatsapp.service-group-ops';
// Note: axiosInstance, ERROR_MESSAGES, whatsappConfig are used within their respective modules now.

class WhatsAppService {
  constructor() {
    console.log('[WhatsApp Service] Initialized');
    // You can add any initializations that might depend on the imported modules here if necessary.
  }

  // Utility methods that were part of the class can be exposed directly
  // or used internally by other methods as needed.
  // If they are only used by methods within this class, they can remain as private methods (_).
  // If they are fundamental operations that other parts of your app might need,
  // they are already exported from whatsapp.service-utils.js.

  // For consistency, we can keep the class structure and call the imported functions.
  // Or, if the class is now just a thin wrapper, consider if a class is still needed
  // or if exporting an object of functions is more appropriate.
  // For this refactor, we'll maintain the class structure.

  _formatChatId(chatId) {
    return formatChatId(chatId);
  }

  _handleError(error, defaultMessage) {
    // This _handleError is specific to the class if it needs to do more,
    // otherwise, the one from utils is used by the op files.
    // For now, we assume the op files use the util's _handleError.
    // If this class method _handleError has different logic, define it here.
    // Otherwise, it might be redundant if all error handling is delegated.
    // Let's assume for now the class might have a high-level way to use it or it's a pass-through.
    return _handleError(error, defaultMessage);
  }

  _extractInviteCode(inviteLink) {
    return _extractInviteCode(inviteLink);
  }


  // Message Operations
  async getMessages(chatId, limit = 100, before = null) {
    // The formatChatId call is now inside the imported getMessages function
    return getMessages(chatId, limit, before);
  }

  async sendTextMessage(chatId, text) {
    // The formatChatId call is now inside the imported sendTextMessage function
    return sendTextMessage(chatId, text);
  }

  async sendFile(phoneNumber, fileUrl, filename, caption = '') {
    return sendFile(phoneNumber, fileUrl, filename, caption);
  }

  // Profile Operations
  async getProfilePicture(phoneNumber) {
    return getProfilePicture(phoneNumber);
  }

  async getContactName(phoneNumber) {
    return getContactName(phoneNumber);
  }

  // Group Operations
  async createGroup(leadData) {
    return createGroup(leadData);
  }

  async setGroupPicture(groupId, pictureUrl) {
    return setGroupPicture(groupId, pictureUrl);
  }

  async setGroupName(groupId, name) {
    return setGroupName(groupId, name);
  }

  async getGroupInviteInfo(inviteLink) {
    // The _extractInviteCode call is inside the imported getGroupInviteInfo function
    return getGroupInviteInfo(inviteLink);
  }

  async joinGroupViaInvite(inviteLink) {
    // The _extractInviteCode call is inside the imported joinGroupViaInvite function
    return joinGroupViaInvite(inviteLink);
  }
}

export default new WhatsAppService();